import { classSet } from '@platform/ui-library';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { getLocalStorage, setLocalStorage } from '@app/utilities';
import { DesignerSetting } from '../DesignerSetting';
import { checkHealth, HealthInfo } from './../utilities/health';

const lastBuildDate = DesignerSetting.s.lastBuild;
const momentStr = moment(DesignerSetting.s.lastBuild).toISOString();
const dateStr = new Date(lastBuildDate).toISOString().split('T')[0];
const timeStr = new Date(lastBuildDate).toLocaleTimeString().split(' ')[0];
const splitTimeStr = timeStr.split(':');
const modHourString = splitTimeStr[0].length === 1 ? 0 + splitTimeStr[0] : splitTimeStr[0];
const modTimeStr = modHourString + ':' + splitTimeStr[1] + ':' + splitTimeStr[2];
const customTimeStr = `( ${dateStr + ' ' + modTimeStr} )`;
const toggleDeveloperText = 'Toggle to ISO';
const toggleDesignerText = 'Toggle to date/time';

const DesignerVersionWidget = () => {
  const [userType, setUserType] = useState('');
  const [currentTimeSrt, setCurrentTimeSrt] = useState('');
  const [toggleText, setToggleText] = useState(toggleDesignerText);
  const [healthInfo, setHealthInfo] = useState<HealthInfo>({
    status: 'LOADING'
  });

  useEffect(() => {
    setUserType(
      getLocalStorage('version-view')
      || setLocalStorage('version-view', 'developer')
    );
    checkHealthInfo();
  }, []);

  useEffect(() => {
    if (userType === 'designer') {
      setCurrentTimeSrt(customTimeStr);
      setToggleText(toggleDeveloperText);
    }

    if (userType === 'developer') {
      setCurrentTimeSrt(momentStr);
      setToggleText(toggleDesignerText);
    }
  }, [userType]);

  const handleToggle = () => {
    const viewType = getLocalStorage('version-view');

    if (viewType === 'designer') {
      setLocalStorage('version-view', 'developer');
      setUserType('developer');
    }

    if (viewType === 'developer') {
      setLocalStorage('version-view', 'designer');
      setUserType('designer');
    }
  };
  const healthClassHandler = () => {
    const { status } = healthInfo;
    if (status === 'UP') {
      return 'online';
    } else if (status === 'DOWN') {
      return 'offline';
    } else {
      return 'loading';
    }
  };

  const checkHealthInfo = async () => {
    try {
      const health = await checkHealth();
      setHealthInfo(health);
    } catch (error) {
      console.log('error', error);
    }

  };

  return (
    <>
      <div className='designer-version'>
        <div className="status">
          <div
            className={classSet([healthClassHandler(), 'status-icon'])}
            data-tip={JSON.stringify(healthInfo, null, 2)}/>
        </div>
        <span>
          {DesignerSetting.s.version} - {DesignerSetting.s.env} -
          {DesignerSetting.s.commit} {currentTimeSrt}
        </span>
        <span
          className="fe icon-info"
          title={toggleText}
          onClick={handleToggle}
        />
      </div>
    </>
  );
};

export default DesignerVersionWidget;
